module.exports = __webpack_public_path__ + "static/media/0.beginning_loop.c6e7d333.mp4";